import { GhostButton, GhostButtonProps } from '@mgh-app/component-library';
import { backgroundColor, boxShadow, combineCls, fontSize, textColor, twCls } from 'style';

export type TabButtonProps = GhostButtonProps & {
  active?: boolean;
};

export const TabButton = ({ active, ...props }: TabButtonProps) => (
  <GhostButton
    size="small"
    className={combineCls(
      twCls(fontSize('text-sm'), active ? textColor('text-blue-100') : textColor('text-grey-900')),
      active && twCls(backgroundColor('bg-white'), boxShadow('shadow-lg')),
    )}
    {...props}
  />
);
